import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-md w-full rounded-2xl border bg-card p-8 text-center space-y-4">
            <div className="w-12 h-12 rounded-xl bg-danger flex items-center justify-center mx-auto">
              <AlertTriangle className="text-danger-foreground" size={22} />
            </div>
            <div>
              <h2 className="font-heading font-bold text-lg">Something went wrong</h2>
              <p className="text-sm text-muted-foreground mt-1 break-all">{String(this.state.error?.message || this.state.error)}</p>
            </div>
            <div className="flex gap-2 justify-center">
              <Button data-testid="error-retry-button" onClick={() => this.setState({ error: null })} variant="outline">Retry</Button>
              <Button data-testid="error-reload-button" onClick={() => window.location.reload()} className="bg-primary hover:bg-primary-hover">Reload page</Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
